/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export default class NodeTreeHelper
{
    private _top: cc.Node;
    public set Top(value: cc.Node) { this._top = value; }

    constructor(top: cc.Node = null)
    {
        if (top != null) { this._top = top; }
    }

    public GetRelativeNodeValue<T>(
        node: cc.Node,
        fnTotal: (node: cc.Node, total: T) => T,
        init: T): T
    {
        const canvas: cc.Node = cc.Canvas.instance.node;

        let total: T = init;
        while (node != null
            && node !== canvas
            && node !== this._top)
        {
            total = fnTotal(node, total);
            node = node.parent;
        }

        return total;
    }

    public TraverseDown(node: cc.Node, handlers: ((node: cc.Node) => void)[]): void
    {
        if (!node.active) { return; }

        handlers.forEach(handler => handler(node));
        node.children.forEach(child => this.TraverseDown(child, handlers));
    }

    public GetRelativeX(node: cc.Node): number
    {
        return this.GetRelativeNodeValue(node, (n: cc.Node, total: number) => total += n.position.x, 0);
    }

    public GetRelativeY(node: cc.Node): number
    {
        return this.GetRelativeNodeValue(node, (n: cc.Node, total: number) => total += n.position.y, 0);
    }

    public GetRelativeWidth(node: cc.Node): number
    {
        return node.width * this.GetRelativeScaleX(node);
    }

    public GetRelativeScaleX(node: cc.Node): number
    {
        return this.GetRelativeNodeValue(node, (n: cc.Node, total: number) => total * n.scaleX, 1);
    }

    public GetRelativeScaleY(node: cc.Node): number
    {
        return this.GetRelativeNodeValue(node, (n: cc.Node, total: number) => total * n.scaleY, 1);
    }

    public GetRelativeScale(node: cc.Node): cc.Vec2
    {
        return this.GetRelativeNodeValue(node,
            (n: cc.Node, total: cc.Vec2) =>
            {
                total.x *= node.scaleX;
                total.y *= node.scaleY;
                return total;
            }, cc.Vec2.ONE);
    }
}
